module.exports = __webpack_public_path__ + "img/banner.e1488cae.png";